// Import all APIs
import { tokenStreamDeckApi } from './fe-management-system-api/token-stream-deck';
import { tokenStateApi } from './fe-management-system-api/token-state';
import { tokenAlertApi } from './fe-management-system-api/token-alert';
import { noteApi } from './fe-management-system-api/note';
import { evaluationApi } from './fe-management-system-api/evaluation';
import { monitoringApi } from './fe-management-system-api/monitoring';
import { communityModeratorApi } from './fe-management-system-api/community-moderator';
import { retrospectiveApi } from './fe-management-system-api/retrospective';
import { narrativeApi } from './fe-management-system-api/narratives';

// Re-export all APIs for backward compatibility
export * from './fe-management-system-api/types';
export { apiClient, getAuthHeaders } from './fe-management-system-api/index';
export { tokenStreamDeckApi } from './fe-management-system-api/token-stream-deck';
export { tokenStateApi } from './fe-management-system-api/token-state';
export { tokenAlertApi } from './fe-management-system-api/token-alert';
export { noteApi } from './fe-management-system-api/note';
export { evaluationApi } from './fe-management-system-api/evaluation';
export { monitoringApi } from './fe-management-system-api/monitoring';
export { communityModeratorApi } from './fe-management-system-api/community-moderator';
export { retrospectiveApi } from './fe-management-system-api/retrospective';
export { narrativeApi } from './fe-management-system-api/narratives';
export type {
  CreateNarrativeRequest,
  UpdateNarrativeRequest,
  NarrativeStakeholderDto,
  NarrativeEventDto,
  SetStakeholdersRequest,
  SetTokensRequest,
  SetEventsRequest,
  NarrativeSummaryDto,
  NarrativeDetailDto,
  NarrativeStatisticsDto,
  GetAllNarrativesResponse,
  SearchNarrativesResponse,
  GetNarrativeStatisticsResponse,
  GetNarrativeByIdResponse,
} from './fe-management-system-api/narratives';

export const feManagementSystemApi = {
  // Token Stream Deck APIs
  getAllTokenStreamDecks: tokenStreamDeckApi.getAllTokenStreamDecks,
  updateTokenStreamDeck: tokenStreamDeckApi.updateTokenStreamDeck,

  // Token State APIs
  updateTokenState: tokenStateApi.updateTokenState,
  searchTokens: tokenStateApi.searchTokens,
  getAllTokenStates: tokenStateApi.getAllTokenStates,
  getTokenStatesPaginated: tokenStateApi.getTokenStatesPaginated,
  getArchivedTokenStates: tokenStateApi.getArchivedTokenStates,
  getTokenState: tokenStateApi.getTokenState,
  listSocialSyncTargets: tokenStateApi.listSocialSyncTargets,
  createSyncTarget: tokenStateApi.createSyncTarget,
  updateSyncResultNote: tokenStateApi.updateSyncResultNote,
  updateSyncTargetEnabled: tokenStateApi.updateSyncTargetEnabled,
  updateTokenContents: tokenStateApi.updateTokenContents,
  getTweetStats: tokenStateApi.getTweetStats,
  getTweetStatsTimeline: tokenStateApi.getTweetStatsTimeline,
  updateTweetStatsConfig: tokenStateApi.updateTweetStatsConfig,

  // Keyword Management APIs
  keywordAutocomplete: tokenStateApi.keywordAutocomplete,
  getAllKeywords: tokenStateApi.getAllKeywords,
  searchTokensByKeywords: tokenStateApi.searchTokensByKeywords,
  updateTokenKeywords: tokenStateApi.updateTokenKeywords,

  // Token Alert APIs
  getTokenAlerts: tokenAlertApi.getTokenAlerts,

  // Note Management APIs
  updateTokenNote: noteApi.updateTokenNote,
  submitForContentGeneration: noteApi.submitForContentGeneration,
  refreshTokenNoteFromDexScreener: noteApi.refreshFromDexScreener,

  // Evaluation Management APIs
  addEvaluatorOpinion: evaluationApi.addEvaluatorOpinion,
  updateEvaluatorOpinion: evaluationApi.updateEvaluatorOpinion,
  updateEvaluationSummary: evaluationApi.updateEvaluationSummary,
  updateRetrospective: evaluationApi.updateRetrospective,
  updateDecision: evaluationApi.updateDecision,

  reportLossRetrospective: retrospectiveApi.reportLoss,

  // Monitoring APIs
  updateMonitoringNote: monitoringApi.updateMonitoringNote,
  // Community Moderator APIs
  getCommunityModerators: communityModeratorApi.getCommunityModerators,

  // Narrative APIs
  createNarrative: narrativeApi.createNarrative,
  getAllNarratives: narrativeApi.getAllNarratives,
  searchNarratives: narrativeApi.searchNarratives,
  getNarrativeStatistics: narrativeApi.getNarrativeStatistics,
  getNarrativeById: narrativeApi.getNarrativeById,
  updateNarrative: narrativeApi.updateNarrative,
  setNarrativeStakeholders: narrativeApi.setNarrativeStakeholders,
  setNarrativeTokens: narrativeApi.setNarrativeTokens,
  setNarrativeEvents: narrativeApi.setNarrativeEvents,
  deleteNarrative: narrativeApi.deleteNarrative,
};

export default feManagementSystemApi;
